import styled from 'styled-components';
import { ConfirmationModalType } from '@libs/types';
import Button from '../button/Button';
import { TransparentButton } from '../transparent-button/TransparentButton';
export const ConfirmationModalContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  padding: 3.2rem 2.8rem 3.4rem;
`;
export const ConfirmationImage = styled.img `
  width: 12.4rem;
  height: 12.4rem;

  margin-bottom: 1.5rem;
`;
export const ConfirmationDesc = styled.div `
  width: 100%;
  margin-top: ${({ description }) => (description ? '2.6rem' : 'none')};
  display: flex;
  justify-content: center;
`;
export const ButtonsWrapper = styled.div `
  display: flex;
  justify-content: space-evenly;

  width: 38rem;

  margin-top: 3.8rem;

  ${({ theme }) => theme.media.mobileL `
     justify-content: space-between;
  `};
`;
export const CancelButton = styled(Button) `
  width: 15.8rem;
  height: 4.8rem;

  ${({ theme }) => theme.media.mobileL `
     width: 17.8rem;
  `};
`;
export const ActionButton = styled(TransparentButton) `
  width: 15.8rem;
  height: 4.8rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ buttonType, theme }) => buttonType === ConfirmationModalType.DELETE
    ? theme.colors.interactive.critical
    : theme.colors.interactive.brandColor};

  ${({ theme }) => theme.media.mobileL `
     width: 17.8rem;
  `};
`;
export const TitleWrapper = styled.div `
  max-width: 35rem;
`;
//# sourceMappingURL=styles.js.map